import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Cell,
  LabelList,
} from "recharts";

const data = [
  {
    name: "Allergic Rhinitis",
    age9_15: 12,
    age16_35: 32,
    age36_80: 20,
  },
  {
    name: "Diaper Dermatitis",
    age9_15: 27,
    age16_35: 9,
    age36_80: 14,
  },
  {
    name: "Gastroesophageal Reflux Disease",
    age9_15: 23,
    age16_35: 14,
    age36_80: 12,
  },
  {
    name: "Insect Bites and Urticaria",
    age9_15: 18,
    age16_35: 23,
    age36_80: 15,
  },
  {
    name: "Musculoskeletal Sprains & Strains",
    age9_15: 22,
    age16_35: 15,
    age36_80: 12,
  },
  {
    name: "Urinary Tract Infections",
    age9_15: 14,
    age16_35: 23,
    age36_80: 20,
  },
  {
    name: "Vulvovaginal candidiasis (yeast infection)",
    age9_15: 16,
    age16_35: 21,
    age36_80: 20,
  },
];
const renderCustomLegend = () => {
  return (
    <div className="p-2 flex justify-end">
      <div>
        <div className="text-sm font-bold mb-2">Ages:</div>
        <div className="flex flex-row gap-2">
          <div className="flex items-center">
            <span
              className="inline-block w-10 h-3"
              style={{ backgroundColor: colors[0] }}
            ></span>
          </div>
          <div className="flex items-center">
            <span
              className="inline-block w-10 h-3"
              style={{ backgroundColor: colors[1] }}
            ></span>
          </div>
          <div className="flex items-center">
            <span
              className="inline-block w-10 h-3"
              style={{ backgroundColor: colors[2] }}
            ></span>
          </div>
        </div>
        <div className="flex flex-row gap-2">
          <div className="flex text-center">
            <span className="inline-block w-10 text-xs-body">9-15</span>
          </div>
          <div className="flex text-center">
            <span className="inline-block w-10 text-xs-body">16-35</span>
          </div>
          <div className="flex text-center">
            <span className="inline-block w-10 text-xs-body">36-80</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const colors = ["#80DEEA", "#00ACC1", "#00838F"];

const CustomBarChart = () => {
  return (
    <>
      {renderCustomLegend()}
      <div style={{ height: "60vh", width: "100%" }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            data={data}
            layout="vertical"
            barCategoryGap="10%"
            margin={{ left: 0, right: 20 }} // Remove margin from left to align bars with Y-Axis
          >
            <XAxis type="number" tickLine={false} />
            <YAxis
              type="category"
              dataKey="name"
              width={150} // Adjusted width for Y-Axis labels
              tickLine={false}
            />
            {/* <Tooltip cursor={{ fill: "transparent" }} />{" "} */}
            <Bar
              dataKey={() => 1}
              stackId="a"
              fill="transparent"
              barSize={35}
            />
            <Bar dataKey="age9_15" stackId="a" barSize={35} fill={colors[0]}>
              {data.map((entry, index) => (
                <Cell
                  key={`cell-9-15-${index}`}
                  fill={colors[0]}
                  radius={[5, 0, 0, 5]} // Rounded left corners for the first bar
                />
              ))}
              <LabelList dataKey="age9_15" position="insideRight" fill="#fff" />
            </Bar>
            <Bar dataKey="age16_35" stackId="a" barSize={35} fill={colors[1]}>
              {data.map((entry, index) => (
                <Cell key={`cell-16-35-${index}`} fill={colors[1]} />
              ))}
              <LabelList
                dataKey="age16_35"
                position="insideRight"
                fill="#fff"
              />
            </Bar>
            <Bar dataKey="age36_80" stackId="a" barSize={35} fill={colors[2]}>
              {data.map((entry, index) => (
                <Cell
                  key={`cell-36-80-${index}`}
                  fill={colors[2]}
                  radius={[0, 20, 20, 0]} // Rounded right corners for the last bar
                />
              ))}
              <LabelList
                dataKey="age36_80"
                position="insideRight"
                fill="#fff"
              />
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};

export default CustomBarChart;
